import { Injectable, signal } from '@angular/core';

/**
 * Rileva assenza di rete via eventi browser `offline` / `online`.
 * Vedi `docs/NETWORK_CONNECTIVITY.md`.
 */
@Injectable({
  providedIn: 'root'
})
export class OfflineDetectionService {
  private readonly isOfflineSignal = signal(typeof navigator !== 'undefined' ? !navigator.onLine : false);

  /** True se il browser segnala assenza di connessione. */
  readonly isOffline = this.isOfflineSignal.asReadonly();

  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    const onOffline = (): void => {
      this.isOfflineSignal.set(true);
      console.log('[OfflineDetectionService] offline');
    };
    const onOnline = (): void => {
      this.isOfflineSignal.set(false);
      console.log('[OfflineDetectionService] online');
    };

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
  }
}
